export * as group from './group/Group.resource';
export * as user from './user/User.resource';
